import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const WHATSAPP_CAMPAIGN_API_URL = "dialer/whatsapp-campaigns/";

export const fetchWhatsappCampaigns = createAsyncThunk("whatsappCampaigns/fetchWhatsappCampaigns", async (params, thunkAPI) => {
    try {
        const state = thunkAPI.getState();
        const token = state.auth.token;
        if (!token) return;

        const response = await axios.get(WHATSAPP_CAMPAIGN_API_URL, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });
        return response?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch whatsapp campaigns list"
        );
    }
});

const whatsappCampaignSlice = createSlice({
  name: "whatsappCampaign",
  initialState: {
    whatsapp_campaigns_list: [],
    whatsapp_campaign_list_loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchWhatsappCampaigns.pending, (state) => {
      state.whatsapp_campaign_list_loading = true;
      state.error = null;
    })
    .addCase(fetchWhatsappCampaigns.fulfilled, (state, action) => {
      state.whatsapp_campaign_list_loading = false;
      state.whatsapp_campaigns_list = action.payload;
    })
    .addCase(fetchWhatsappCampaigns.rejected, (state, action) => {
      state.whatsapp_campaign_list_loading = false;
      state.error = action.payload || "Something went wrong";
      state.whatsapp_campaigns_list = [];
    });
  },
});

export default whatsappCampaignSlice.reducer;
